export interface NavItem {
  name: string;
  label: string;
  longLabel?: string;
  href: string;
  icon: string;
  activeIcon: string;
  dot?: boolean;
}


export const NAV_ITEMS: NavItem[] = [
  {
    name: "home",
    label: "خانه",
    longLabel: "صفحه اصلی",
    href: "/",
    icon: "home",
    activeIcon: "home-fill",
  },
  {
    name: "search",
    label: "جستجو",
    href: "/search",
    icon: "search",
    activeIcon: "search-fill",
  },
  {
    name: "my-courses",
    label: "دوره‌های من",
    href: "/my-courses",
    icon: "my-courses",
    activeIcon: "my-courses-fill",
  },
  {
    name: "profile",
    label: "پروفایل",
    href: "/profile",
    icon: "profile",
    activeIcon: "profile-fill",
  },
];
